// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__w3BGh","productName":"Table_productName__3isoY"};